/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 15
// module chunks = 1